import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { AuctionSealedResponseDto } from '../schemas/auction-sealed-response.dto';
import { AUCTION_SEALED_FLOW_API_BASE_URL } from '../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class AuctionSealedApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUCTION_SEALED_FLOW_API_BASE_URL)}/AuctionSealed`;

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<AuctionSealedResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', String(tradingProcedureId)))
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<AuctionSealedResponseDto>()
            .withHttpParams(new HttpParams().set('id', String(id)))
            .build()
            .send();
    }
}
